import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Select2OptionData } from 'ng2-select2/ng2-select2.interface';
import swal from 'sweetalert2';

import { MenuUtility } from '../../shared/utilities/menu.utility';
import { Select2Utility } from '../../shared/utilities/select2.utility';
import { UserService } from '../../shared/services/user.service';
import { SessionService } from '../../shared/services/session.service';
import { CitieService } from '../../shared/services/citie.service';
import { AuthService } from '../../shared/services/auth.service';

import { Lista } from '../../shared/models/lista.model';
import { error } from 'util';
import { User } from '../../shared/models/user.model';
import { Validators } from '@angular/forms/src/validators';
import { concat } from 'rxjs/operators/concat';

@Component({
  selector: 'office-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  contrato: string;
  direccionoficina: string;
  telefonooficina: string;
  selectedOptionOfi: string;
  direccionresidencia: string;
  telefonoresidencia: string;
  telefonocelular: string;
  selectedOptionRes: string;
  email: string;
  selectedOptionCorres: string;
  selectedOptionAutorizaFE: string;
  contrasena: string;
  nuevacontrasena: string;
  confirmacontrasena: string;
  showActualizarDatos: boolean;
  actualizaDatos: boolean;
  contratante: boolean;

  citiesOfi: Select2OptionData[];

  public selectedCitieOfi: string;

  public selectedCitieOfiTexto: string;

  citieOfi: string;

  citiesRes: Select2OptionData[];

  public selectedCitieRes: string;

  public selectedCitieResTexto: string;

  citieRes: string;

  user: User;

  identication: string;

  constructor(
    private userService: UserService,
    private _sessionService: SessionService,
    private _citieService: CitieService,
    private router: Router,
    private _authService: AuthService,
    private _router: Router,
  ) {
    this.user = this._sessionService.getCurrentUser();
  }

  ngOnInit() {

    let _cache = this._sessionService.getCache();
    this.selectedOptionOfi = '';
    this.selectedOptionRes = '';
    this.contrasena = '';
    this.nuevacontrasena = '';
    this.confirmacontrasena = '';
    this.actualizaDatos = true;
    this.contratante = this._sessionService.getCurrentUser().actualizacionMenu;

    if (this._sessionService.getCurrentUser().age < 18) {
      this.showActualizarDatos = false;
    }
    else {
      this.showActualizarDatos = true;
    }
    //console.log(this._sessionService.getCurrentUser().age);
    //console.log(this.showActualizarDatos);
    //console.log(this.actualizaDatos);
    this._citieService.getCities().subscribe(
      resCiti => {

        this.identication = '-';

        if (!this._sessionService.getCurrentUser().actualizacionMenu) {
          this.identication = this._sessionService.getCurrentUser().documentId;
        }

        let _res = this.toSelect2(resCiti);

        let _optionCities = _res;
        let _options = _optionCities;

        this.citiesOfi = _options;
        this.citiesRes = _options;

        this.userService.getDataUser(this._sessionService.getSelectContract(), this.identication).subscribe(
          res => {
            //console.log(res);            

            this.contrato = res.contractNumber;
            this.direccionoficina = res.officeAddress;
            this.telefonooficina = res.officePhone;
            this.selectedOptionOfi = res.codDeptoOficina;
            this.direccionresidencia = res.residentialAddress;
            this.telefonoresidencia = res.residentialPhone;
            this.telefonocelular = res.celphone;
            this.selectedOptionRes = res.codDeptoMunicipioResidencia;
            this.email = res.email;
            this.selectedOptionCorres = res.whantEmail;
            this.selectedOptionAutorizaFE = res.feAutorization;
            this.user.contractNumber = res.contractNumber;
            this.user.officeAddress = res.officeAddress;
            this.user.officePhone = res.officePhone;
            this.user.officeCity = res.codDeptoOficina;
            this.user.residentialAddress = res.residentialAddress;
            this.user.residentialPhone = res.residentialPhone;
            this.user.celphone = res.celphone;
            this.user.residentialCity = res.codDeptoMunicipioResidencia;
            this.user.email = res.email;
            this.user.whantEmail = res.whantEmail;

          },
          err => {
            console.log(err);
          }
        )

      },
      err => {
        console.log(err);
      }
    )



    MenuUtility.selectOption(null);
    Select2Utility.refresh();
  }

  toSelect2(source: Lista[]): any[] {

    var _array = [];

    for (let s of source) {
      let _obj = {
        id: s.id + '',
        text: s.text + ''
      };
      _array.push(_obj);
    }

    return _array;
  }

  getOptionDefault(texto: string): any[] {
    return [{ id: '-1', text: texto }];
  }

  public changedOfi(e: any): void {
    this.selectedCitieOfi = e.value;
    this.selectedCitieOfiTexto = e.data[0].text;
    this.selectedOptionOfi = e.value;
    this.citieOfi = '';

    if (this.selectedCitieOfi !== '-1' && this.selectedCitieOfi !== '') {
      this.citieOfi = this.selectedCitieOfi;
      //console.log(this.citieOfi);
    }
  }

  public changedRes(e: any): void {
    this.selectedCitieRes = e.value;
    this.selectedCitieResTexto = e.data[0].text;
    this.selectedOptionRes = e.value;
    this.citieRes = '';

    if (this.selectedCitieRes !== '-1' && this.selectedCitieRes !== '') {
      this.citieRes = this.selectedCitieRes;
      //console.log(this.citieRes);
    }
  }

  public changedCorres(e: any): void {
    this.selectedOptionCorres = e.value;
  }

  public changedAutorizaFE(e : any): void {
    this.selectedOptionAutorizaFE = e.value;
  }

  validarDatos() {

    //direccionoficina
    if (this.direccionoficina === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar la dirección de oficina</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //telefonooficina
    if (this.telefonooficina === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar el teléfono de oficina</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //direccionresidencia
    if (this.direccionresidencia === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar la dirección de residencia</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //telefonoresidencia
    if (this.telefonoresidencia === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar el teléfono de residencia</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //telefonocelular
    if (this.telefonocelular === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar el celular</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //autoriza fe
    if (this.selectedOptionAutorizaFE === '' && this.contratante) {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta seleccionar la autorización expresa a MedplusMP para el envío al correo electrónico de facturas, respuesta a PQR y novedades, sustituyendo el envío físico</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }
    
    //email
    if (this.email === '') {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">Falta digitar el EMail</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    let EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;

    if (this.email != "" && (this.email.length <= 5 || !EMAIL_REGEXP.test(this.email))) {
      swal({
        title: 'Actualización Datos',
        html: '<p style="font-size:14px">El formato de correo no es válido</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    let _html = '';

    _html = `
    <p style="font-size: 15px; text-align: left; font-weight: bold">Confirma los datos a actualizar:</p>
    <table id="tableResumenDatos" class="table table-bordered">
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Contrato</td>
        <td>${this.contrato}</td>
      </tr>
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Dirección Oficina</td>
        <td>${this.direccionoficina}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Teléfono Oficina</td>
        <td>${this.telefonooficina}</td>
      </tr> 
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Ciudad Oficina</td>
      <td>${this.selectedCitieOfiTexto}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Dirección Residencia</td>
        <td>${this.direccionresidencia}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Teléfono Residencia</td>
        <td>${this.telefonoresidencia}</td>
      </tr>
      <tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Teléfono Celular</td>
        <td>${this.telefonocelular}</td>
      </tr>
      <tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Ciudad Residencia</td>
        <td>${this.selectedCitieResTexto}</td>
      </tr>
      <tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Email</td>
        <td>${this.email}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Donde desea recibir correspondencia</td>
      <td><p>` + this.selectedOptionCorres + `</p></td>
      </tr>
      <td style="background-color: #1d7bbb; color: #ffff">Autorizo expresamente a MedplusMP para el envío al correo electrónico de facturas, respuesta a PQR y novedades, sustituyendo el envío físico</td>
      <td><p>` + this.selectedOptionAutorizaFE + `</p></td>
      </tr>
    </table>`;

    swal({
      width: 800,
      padding: 30,
      showCloseButton: true,
      html: _html,
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-success btn-confirm-modal',
      confirmButtonText: 'Confirmar',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-info',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      onOpen: () => {
        jQuery("#tableResumenDatos").addClass("tableConfirmaDatos");
      },
      preConfirm: () => {
        return new Promise((resolve) => {

          this.userService.postGrabaHistoricoDatos({
            user: this.user.user, contractNumber: this.user.contractNumber, officeAddress: this.user.officeAddress,
            officePhone: this.user.officePhone, officeCity: this.user.officeCity, residentialAddress: this.user.residentialAddress,
            residentialPhone: this.user.residentialPhone, celphone: this.user.celphone, residentialCity: this.user.residentialCity,
            email: this.user.email, news: this.user.news, whantEmail: this.user.whantEmail
          }).subscribe(
            res => {

              //console.log(res.confirma);

              if (res.confirma) {

                this.identication = '-';
                if (!this._sessionService.getCurrentUser().actualizacionMenu) {
                  this.identication = this._sessionService.getCurrentUser().documentId;
                }

                this.userService.postActualizaDatos({
                  user: this.user.user, contractNumber: this.user.contractNumber, officeAddress: this.direccionoficina,
                  officePhone: this.telefonooficina, officeCity: this.selectedOptionOfi, residentialAddress: this.direccionresidencia,
                  residentialPhone: this.telefonoresidencia, celphone: this.telefonocelular, residentialCity: this.selectedCitieRes,
                  email: this.email, news: this.selectedOptionCorres, whantEmail: this.selectedOptionCorres, documentId: this.identication,
                  feAutorization: this.selectedOptionAutorizaFE
                }).subscribe(
                  resact => {

                    if (resact.confirma) {
                      swal({
                        title: 'Actualización de Datos',
                        html: resact.message,
                        type: resact.type,
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      }).then((result) => {
                        if (result.value) {
                          this.router.navigate(['/office/home']);
                        }
                      });
                    }
                    else {
                      swal({
                        title: 'Actualización de Datos',
                        html: resact.message,
                        type: resact.type,
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      });
                    }
                  }, err => {
                    if (err.status === 406) {

                      swal({
                        width: 500,
                        title: 'Actualización de Datos',
                        html: `<p style="font-size:14px">${err.error.message}</p>`,
                        type: 'warning',
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      });

                    } else {

                      swal({
                        width: 500,
                        title: 'Actualización de Datos',
                        html: `<p style="font-size:14px">Ha ocurrido un inconveniente. Por favor intentelo de nuevo</p>`,
                        type: 'warning',
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      });

                    }
                  }
                  );
              }
              else {
                swal({
                  title: 'Actualización de Datos',
                  html: res.message,
                  type: res.type,
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false,
                  focusConfirm: false
                });
              }

            }, err => {
              if (err.status === 406) {

                swal({
                  width: 500,
                  title: 'Actualización de Datos',
                  html: `<p style="font-size:14px">${err.error.message}</p>`,
                  type: 'warning',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false,
                  focusConfirm: false
                });

              } else {

                swal({
                  width: 500,
                  title: 'Actualización de Datos',
                  html: `<p style="font-size:14px">Ha ocurrido un inconveniente. Por favor intentelo de nuevo</p>`,
                  type: 'warning',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false,
                  focusConfirm: false
                });

              }
            }
            );

        })
      }
    });
  }

  modificarContrasena() {

    //validación digitación contraseña anterior
    if (this.contrasena === '') {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">Falta digitar la contraseña anterior</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //validación digitación nueva contraseña
    if (this.nuevacontrasena === '') {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">Falta digitar la nueva contraseña</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //validación digitación nueva contraseña
    if (this.confirmacontrasena === '') {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">Falta digitar la confirmación de la nueva contraseña</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //validación longitud nueva contraseña
    if (this.nuevacontrasena.length < 7) {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">La nueva contraseña debe tener por lo menos 7 caracteres</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //validación longitud confirmación nueva contraseña
    if (this.confirmacontrasena.length < 7) {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">La confirmación de la nueva contraseña debe tener por lo menos 7 caracteres</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    //validación igualdad nuevas contraseñas
    if (this.nuevacontrasena !== this.confirmacontrasena) {
      swal({
        title: 'Cambio contraseña',
        html: '<p style="font-size:14px">La nueva contraseña y su confirmación no coinciden</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    this._authService.postValidaPassOld(this.user.user, this.contrasena).subscribe(
      res => {
        //console.log(res.confirma);

        if (res.confirma) {

          this._authService.postCambiaPassBd(this.user.user, this.nuevacontrasena, Number.parseInt(this.user.contractNumber)).subscribe(
            resCambio => {
              this.cleanFields();
              swal({
                title: 'Cambio contraseña',
                html: `<br/><p style="font-size: 14px">${resCambio.message}</p>`,
                type: resCambio.type,
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              }) 
              .then((value) => {
                  if(value){
                    this._router.navigate(['/office/home']);
                  }
              }
            );
            }, err => {
              this.cleanFields();
              swal({
                title: 'Cambio contraseña',
                html: `<br/><p style="font-size: 14px">${err.error.message}</p>`,
                type: err.error.type,
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
            }

          );
        }
      }, err => {
        swal({
          title: 'Cambio contraseña',
          html: `<br/><p style="font-size: 14px">${err.error.message}</p>`,
          type: err.error.type,
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
      }

    );

  }

  cleanFields() {
    this.contrasena = '';
    this.nuevacontrasena = '';
    this.confirmacontrasena = '';
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/profile/profile.component.ts